export const busReducerSelector = state => state.busReducer;

export const busTemplateSelector = state => state.busReducer.busesTemplateData;
